import { createFileRoute } from "@tanstack/react-router";
import { AriSamplePage, ariSampleHead } from "@/features/company-story";

export const Route = createFileRoute("/kinako-hill-shibas")({
    component: AriSamplePage,
    head: ariSampleHead,
});
